export default {
  logout: ['post', '/auth/logout'],
  postLogin: ['post', '/auth/login'], // 登录
  postCheckVerifyCode: ['post', '/auth/verification_code'],
  getVerifyCode: ['put', '/auth/verification_code'], // 获取验证码
  getEmployeePermission: ['get', '/micro_structure/employee/permissions'],
  getUserInfo: ['get', '/auth/current_user_info']
}
